import React from "react";
import { Media } from "reactstrap";

export interface ImageTypes {
  body?: boolean;
  className?: string;
  src: any;
  alt: any;
  ref?: any;
  onLoad?: () => void;
  style?: Object;
  height?: number;
  id?: string;
  title?: string;
  width?: number;
}

function Image(props: ImageTypes) {
  const srcStr = typeof props.src === "string" ? props.src : "";
  if (srcStr.includes("loader.gif") || (srcStr.includes("loader") && srcStr.includes(".gif"))) {
    return (
      <div className="theme-loader-container" style={{ minHeight: "180px" }}>
        <div className="theme-loader">
          <div className="loader-p"></div>
        </div>
      </div>
    );
  }

  return (
    <Media {...props} />
  );
}

export default Image;